module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-transfer",
    attrs: {
      "id": "modal-transfer",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "id": "someTab"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "profile"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "pane-answer-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "simulation margin-t20"
  }, [_c('h3', {
    staticClass: "inline"
  }, [_vm._v("Fazer simulação")]), _vm._v(" "), _c('div', {
    staticClass: "form-group info-transfer-box inline"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Valor da Transferência (R$)*:")]), _vm._v(" "), _c('button', {
    staticClass: "inline bold btn-charge btn-charge-minus",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.decrement()
      }
    }
  }, [_c('i', {
    staticClass: "icon-minus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "inline form-control bold",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "0,00"
    },
    domProps: {
      "value": _vm.transferValue
    },
    on: {
      "input": function($event) {
        return _vm.changeTransferValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "inline bold btn-charge btn-charge-plus",
    attrs: {
      "type": "button",
      "name": "button",
      "autofocus": "autofocus"
    },
    on: {
      "click": function($event) {
        return _vm.increment()
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group percentual-box inline"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("*Taxa de Transferência (2% sobre o valor) R$:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxTransferValue),
      expression: "taxTransferValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.taxTransferValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxTransferValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group total-box inline"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Transferência + Taxa (R$):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalTransferValue),
      expression: "finalTransferValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.finalTransferValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalTransferValue = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {}, [_c('input', {
    staticClass: "check-terms",
    attrs: {
      "id": "modal-info",
      "type": "checkbox",
      "name": "modal-info",
      "value": "1"
    },
    on: {
      "click": function($event) {
        return _vm.doNotShow()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-terms",
    attrs: {
      "for": "modal-info"
    }
  }, [_vm._v("\n            Não mostrar mais esta informação.\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/CarteiraEnvia.svg"),
      "alt": "",
      "width": "70"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../static/Transferencia_verde.png"),
      "alt": "",
      "width": "70"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../static/CarteiraEnvia.svg"),
      "alt": "",
      "width": "70"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('h1', [_vm._v("move mais transferência de saldo")]), _vm._v(" "), _c('h4', [_vm._v("Precisando de créditos e não tem como fazer uma recarga?")])]), _vm._v(" "), _c('h4', [_vm._v("Faça sua recarga à distância através da transferência entre contas.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home",
      "aria-controls": "home",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Descrição")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#profile",
      "aria-controls": "profile",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Taxa de serviço")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#messages",
      "aria-controls": "messages",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Quem pode")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#settings",
      "aria-controls": "settings",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Me ajuda")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "home"
    }
  }, [_c('h4', {
    staticClass: "bold-600 upper"
  }, [_vm._v("\n                descrição\n                "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pane-answer-box"
  }, [_c('p', [_vm._v("\n                  Agora você poderá receber e transferir saldo para qualquer outro contrato com toda comodidade e praticidade.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Agora, mesmo quando você estiver sem saldo ou sem poder fazer uma recarga naquele momento, você poderá pedir aos\n                  seus amigos e familiares para lhe transferirem o saldo que necessita para passar pelas praças de pedágio automaticamente.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Este serviço está disponível para todos os clientes "), _c('b', [_vm._v("Pré-pagos")]), _vm._v(" Pessoa Física.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Para mais informações, leia o "), _c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
      "target": "_blank",
      "title": "Termos e Condições"
    }
  }, [_vm._v("Termo de Uso do Serviço")]), _vm._v(".\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "bold-600 upper"
  }, [_vm._v("\n                taxa\n                "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  A taxa de serviço é de "), _c('b', [_vm._v("2%")]), _vm._v(" sobre o valor a ser transferido.\n                  "), _c('br'), _c('br'), _vm._v("\n                  O contrato de origem tem que ter saldo igual ou maior à soma do valor a ser transferido mais o valor da taxa de serviço.\n                  Se tiver, qualquer valor de transferência é permitido.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "messages"
    }
  }, [_c('h4', {
    staticClass: "bold-600 upper"
  }, [_vm._v("\n                quem pode\n                "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pane-answer-box"
  }, [_c('p', [_vm._v("\n                  Não é preciso contratar esse serviço. Para usar o Move Mais Transferência de Saldo, basta ter saldo em seu plano Pré-pago\n                  Pessoa Física com status "), _c('b', [_vm._v("Ativo")]), _vm._v(".\n                  "), _c('br'), _c('br'), _vm._v("\n                  O cliente que atender aos critérios para utilizar o serviço, poderá fazer transferência de saldo entre contratos Move Mais,\n                  na mesma conta ou entre contas diferentes.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Pode receber o crédito da transferência se estiver com status "), _c('b', [_vm._v("Aguardando Ativação, Ativo, Inadimplente, Bloqueado por\n                  saldo ")]), _vm._v("e "), _c('b', [_vm._v("A encerrar")]), _vm._v(".\n                  "), _c('br'), _c('br'), _vm._v("\n                  Não pode receber a transferência de saldo se o contrato estiver com status "), _c('b', [_vm._v("Cancelado")]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "red"
  }, [_c('b', [_vm._v("IMPORTANTE:")]), _vm._v(" A transferência efetivada não poderá ser desfeita.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "settings"
    }
  }, [_c('h4', {
    staticClass: "bold-600 upper"
  }, [_vm._v("\n                me ajuda\n                "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pane-answer-box"
  }, [_c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    O que é a Transferência de Saldo?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Trata-se de um serviço disponibilizado pela Move Mais aos seus clientes Pré-pagos Pessoa Física.\n                      O cliente que atender aos critérios para utilizar o serviço, poderá fazer transferência de saldo entre\n                      contratos Move Mais, na mesma conta ou entre contas diferentes.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Quem pode solicitar o serviço?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Cliente Move Mais com situação "), _c('b', [_vm._v("“Ativo”")]), _vm._v(" e contrato Pré-pago Manual ou Pré-pago Automático.\n                      A transferência pode ser entre contratos de contas diferentes ou entre contratos de uma mesma conta.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Qual o valor/percentual da taxa de serviço?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      A "), _c('b', [_vm._v("Taxa")]), _vm._v(" cobrada será de "), _c('b', [_vm._v("2%")]), _vm._v(" sobre o valor transferido.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Quem pode receber a transferência?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Clientes com as seguintes situações: "), _c('b', [_vm._v("\"Aguardando Ativação\", \"Ativo\", \"Inadimplente\", \"Bloqueado por\n                      saldo\" ")]), _vm._v("e "), _c('b', [_vm._v("\"A encerrar\"")]), _vm._v(".\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Quem não pode receber a transferência?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Clientes com situação "), _c('b', [_vm._v("\"Cancelado\"")]), _vm._v(".\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Se houver erro na transferência de saldo, que segurança a MOVE MAIS me oferece?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Todo o processo de transferência de saldo, desde os dados do receber da transferência quanto o valor,\n                      é de inteira responsabilidade de quem o fez. Todo o processo é feito através de senha, de uso exclusivo do\n                      titular da conta.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    A taxa será descontada do cliente que enviar o crédito ou posso selecionar que o crédito seja descontado do recebedor?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      A taxa de 2% será descontado de quem fizer a transferência ("), _c('b', [_vm._v("emissor")]), _vm._v(").\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Sou Pré-pago automático,  se eu transferir todo o meu saldo será  disparada uma nova recarga?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Sim! Se você é cliente Pré-pago automático será disparada uma nova recarga caso faça a\n                      transferência de todo seu saldo ou após a transferência seu saldo fique abaixo dos 40% do valor\n                      estipulado para a recarga automática.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Não sei o CPF ou contrato do favorecido, a Central de Relacionamento poderá informar?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Não!\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n                    Quem recebeu e quem fez a transferência será notificado?\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                      Sim! Tanto quem fez a transferência quanto quem receber, será notificado através de SMS da efetivação da operação.\n                    ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-430c8754!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-transfer.vue
// module id = 2112
// module chunks = 1